<template>
  <div id="addBadge" class="tab-pane" role="tabpanel">
    <!-- .edu_program -->

    <b-form-group
      id="input-group-3"
      :label="$t('discussions.title')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.title"
        type="text"
        :placeholder="$t('discussions.title')"
      />
    </b-form-group>
    <!-- .content -->
    <b-form-group
      id="input-group-4"
      :label="$t('discussions.content')"
      label-for="input-4"
    >
      <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
        id="input-4"
        v-model="newItem.content"
        :placeholder="$t('discussions.content')"
      >
      </ckeditor>
    </b-form-group>

    <div class="form-group">
      <button type="button" class="btn btn-primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </button>
    </div>
  </div>
</template>

<script>
import Controller from "../../../../Controllers/DiscussionsController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";

const controller = new Controller();
export default {
  name: "DiscussionsForm",
  components: {
    // CKEditor
  },

  props: ["newItem"],
  data() {
    return {
      file: {},
      
      edu_program: [],
      parent: [],
    };
  },
  methods: {
   async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.edu_program_id = localStorage.getItem("eduProgram");
      this.newItem.user_id = Auth.USER.id;
      let ret =await controller.From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
